import { Directive, forwardRef, Input, TemplateRef } from '@angular/core';
import { IRowConfig } from '@app/infrastructure/data-list/grid/grid.model';

export abstract class CustomRow<T = unknown> {
	public insertAtIndex?: number | InsertAtIndexFn<T>;
	public tmpRef!: TemplateRef<unknown>;
}

export type InsertAtIndexFn<T = unknown> = (defaultRows: IRowConfig<T>[]) => number;

export function isInsertAtIndexFn<T>(
	insertAtIndex: number | InsertAtIndexFn<T> | undefined,
): insertAtIndex is InsertAtIndexFn<T> {
	return typeof insertAtIndex === 'function';
}

@Directive({
	selector: '[appCustomRow]',
	providers: [
		{
			provide: CustomRow,
			useExisting: forwardRef(() => CustomRowDirective),
		},
	],
})
export class CustomRowDirective {
	@Input('appCustomRow') public insertAtIndex?: number | InsertAtIndexFn;

	constructor(public tmpRef: TemplateRef<unknown>) {}
}
